import { useEffect } from "react";
import { ScopeType } from "sockapi/scope-types";
import { useTeamId, useSockClient } from "stores/ServerInteractionStore";
import { useTeamScopeState, usePuzzleData } from "stores/ScopeStateStore";
import { useNavStore } from "stores/NavStore";
import {
  useUpdateBrowserWidePersistentState,
  makeDefaultCutsceneState,
} from "stores/BrowserWidePersistentState";

import { Link } from "components/Link";
import { LargeSpinner } from "components/Loading";
import { Paper } from "components/Material";
import { PuzzlePageWrapper } from "pages/PuzzlePage";
import "./VictoryPage.css";

function VictoryPage() {
  const sockClient = useSockClient();
  const teamId = useTeamId();
  const teamScopeState = useTeamScopeState();
  const finalCutscenePuzName =
    Object.values(teamScopeState?.puzzles ?? {}).find(
      ({ isFinalCutscene = false }) => isFinalCutscene
    )?.puzName ?? null;
  const setRedirectCommand = useNavStore((state) => state.setRedirectCommand);
  const puzData = usePuzzleData(finalCutscenePuzName);
  const updateBrowserWidePersistentState =
    useUpdateBrowserWidePersistentState();

  useEffect(() => {
    if (teamScopeState === null) return;
    // If the final cutscene is not unlocked, then the user should
    // not have access to this page.
    if (finalCutscenePuzName === null) setRedirectCommand({ path: "/puzzles" });
  }, [teamScopeState, finalCutscenePuzName, setRedirectCommand]);

  useEffect(() => {
    if (finalCutscenePuzName === null) return;
    if (teamId === null) return;
    if (puzData === null) return;
    const puzName = finalCutscenePuzName;
    updateBrowserWidePersistentState({
      cutscenesState: {
        [puzName]: makeDefaultCutsceneState(),
      },
      completedStoryBeats: { [puzName]: true },
    });
    if (puzData.solveTime === undefined)
      sockClient
        .sendScopeStepAndWaitAsync(
          {
            type: ScopeType.TEAM_CUTSCENES,
            teamId,
          },
          {
            setCutsceneComplete: puzName,
          }
        )
        .catch(console.error);
  }, [
    finalCutscenePuzName,
    sockClient,
    teamId,
    updateBrowserWidePersistentState,
    puzData,
  ]);

  if (
    teamId === null ||
    finalCutscenePuzName === null ||
    puzData?.solveTime === undefined
  )
    return <LargeSpinner />;
  return (
    <PuzzlePageWrapper>
      <div className="centered-page victory-page">
        <img
          className="victory-page-img"
          src="/static/images/bg/island-finale.png"
        />
        <h1>Congratulations on finishing Galactic Puzzle Hunt 2025!</h1>
        <div>
          You will receive more information shortly via email. Thank you for
          playing, and please fill out our{" "}
          <a
            target="_blank"
            href="https://forms.gle/hgnND93C58iQAfZF6"
            rel="noreferrer"
          >
            feedback form
          </a>
          !
        </div>
        <div>
          Solutions for puzzles you&apos;ve solved are now available, with the
          exception of some that might spoil you on puzzles you haven&apos;t yet
          solved.
        </div>
        <Link route="puzzles" style={{ textDecoration: "none" }}>
          <Paper rotate={0}>Back to world</Paper>
        </Link>
      </div>
    </PuzzlePageWrapper>
  );
}

export default VictoryPage;
